import { ReactNode } from 'react';
import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Badge, Link, TimeIndicator } from 'components/common';

import type { BadgeCategory } from 'components/common/Badge';

type Props = {
  children: ReactNode;
  href?: string;
  category: BadgeCategory;
} & (
  | {
      text?: never;
      timePrefix?: string;
      timeString: string;
    }
  | {
      text: string;
      timePrefix?: never;
      timeString?: never;
    }
);

const WrapperElement = ({ children, href }) =>
  href ? (
    <Link href={href} linkColor="inherit" style={{ textDecoration: 'none' }}>
      {children}
    </Link>
  ) : (
    <div>{children}</div>
  );

const HomeDetailsItem = ({
  children,
  href,
  category,
  text,
  timePrefix,
  timeString
}: Props) => {
  const { language, theme } = useReduxState();

  return (
    <div className="home-details-item">
      <WrapperElement href={href}>
        <div className={`item ${href ? 'item-link' : ''}`}>
          {children}

          <div className="time">
            <Badge
              category={category}
              text={
                <span>
                  {timeString ? (
                    <>
                      {timePrefix ? (
                        <span className="time-prefix">{`${timePrefix} `}</span>
                      ) : null}
                      <span className="time-value">
                        <TimeIndicator
                          language={language}
                          timeString={timeString}
                        />
                      </span>
                    </>
                  ) : null}

                  {text ? <span>{text}</span> : null}
                </span>
              }
            />
          </div>
        </div>
      </WrapperElement>

      <style jsx>{`
        .item {
          align-items: flex-start;
          background-color: white;
          border-radius: ${theme.cardBorderRadius};
          box-shadow: ${theme.cardBoxShadow};
          color: ${theme.textColor};
          display: flex;
          flex-direction: column;
          gap: 15px;
          outline: 0;
          padding: 15px;
          position: relative;
          text-decoration: none;
          transition: box-shadow 0.3s;
        }
        .item-link:focus,
        .item-link:hover {
          box-shadow: ${theme.cardBoxShadowActive};
        }
        .time {
          margin-right: 5px;
        }
        .time-prefix + .time-value {
          text-transform: lowercase;
        }
        @media (min-width: ${breakpoints.small}px) {
          .item {
            align-items: center;
            flex-direction: row;
          }
        }
      `}</style>
    </div>
  );
};
export default HomeDetailsItem;
